import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { ParametrosComponent } from './parametros.component';
import { SharedModule } from 'src/app/view/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import esMX from '@angular/common/locales/es-MX';

registerLocaleData(esMX, 'es-MX');

@NgModule({
  declarations: [ParametrosComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    ReactiveFormsModule,
  ],
  exports: [ParametrosComponent]
})
export class ParametrosModule { }
